export const actionType = {

    MESSAGES_REQUEST: 'MESSAGES_REQUEST',
    MESSAGES_SUCCESS: 'MESSAGES_SUCCESS',
    MESSAGES_FAILURE: 'MESSAGES_FAILURE', 

    SEND_MESSAGE : 'SEND_MESSAGE'

    
};